import { isAbortError } from './isAbortError'

export default function isNotAnonAxiosError(err) {
  // Filter out AbortErrors from navigation-based request cancellation
  if (isAbortError(err)) {
    return false
  }

  if (!('isAxiosError' in err) && !err.isAxiosError) {
    return true
  }

  if (('response' in err && err.response) || ('code' in err && err.code)) {
    return true
  } else {
    return false
  }
}
